<template>
  <section :id="$style.history">
    <main-title
      :class="$style.title"
      :main_title="'年表'"
      :sub_title="'History'"
      :color="'#403f3f'"
      :align="'center'"
    ></main-title>

    <div :id="$style.chronogy">
      <div :id="$style.pritohigh">
        <dl>
          <div>
            <dt>1974(0歳)</dt>
            <dd>
              石川県根上町(現・能美市)で父・昌雄と母・さえ子の二男として生まれる体重3960g
              <a :class="$style.eventdate">(6月12日)</a>
            </dd>
          </div>

          <div>
            <dt>1976(2歳)</dt>
            <dd>
              根上町立山口保育園に入園
              <a :class="$style.eventdate">(4月)</a>
            </dd>
          </div>

          <div>
            <dt>1981(7歳)</dt>
            <dd>
              根上町立浜小学校に入学
              <a :class="$style.eventdate">(4月)</a>
            </dd>
          </div>

          <div>
            <dt>1985(11歳)</dt>
            <dd>根上町武道館で柔道を始める</dd>
            <dd>根上少年野球クラブに入部(捕手)</dd>
          </div>

          <div>
            <dt>1987(13歳)</dt>
            <dd>根上町立根上中学校に入学 軟式野球部に入部</dd>
          </div>

          <div>
            <dt>1989(15歳)</dt>
            <dd>3年生時、投手に転向 エースナンバー「1」をもらう</dd>
            <dd>春の地区大会でエースで「4」番、キャプテンとなる</dd>
            <dd>石川県中学野球大会で優勝2度</dd>
            <dd>中部地区選抜で準優勝1度</dd>
          </div>

          <div>
            <dt>1990(16歳)</dt>
            <dd>
              星稜高校に入学 野球部へ入部
              <a :class="$style.eventdate">(4月)</a>
            </dd>
            <dd>
              第72回全国高校野球選手権大会(夏の甲子園)に出場
              <a :class="$style.eventdate">(8月)</a>
            </dd>
          </div>

          <div>
            <dt>1991(17歳)</dt>
            <dd>
              第73国高校野球選手権大会(夏の甲子園)に出場
              <a :class="$style.eventdate">(8月)</a>
            </dd>
            <dd>3回戦竜ヶ崎第一高校戦で甲子園第1号ホームランを放つ</dd>
          </div>

          <div>
            <dt>1992(18歳)</dt>
            <dd>
              第64回選抜高校野球大会(春の甲子園)で3本塁打
              <a :class="$style.eventdate">(3月)</a>
            </dd>
            <dd>
              ゴジラのニックネームを拝命
              <a :class="$style.eventdate">(3月)</a>
            </dd>
            <dd>
              第74回全国高校野球選手権大会(夏の甲子園)に出場
              <a :class="$style.eventdate">(8月)</a>
            </dd>
            <dd>
              2回戦の明徳義塾高校(高知)戦で5打席連続敬遠という前代未聞の作戦の前に敗退
              <a :class="$style.eventdate">(8月)</a>
            </dd>
            <dd>
              べにばな国体(山形)決勝戦にて高校通算60本塁打を記録
              <a :class="$style.eventdate">(10月)</a>
            </dd>
            <dd>
              ドラフトで巨人、阪神、中日、ダイエーの4球団が指名し巨人軍に入団
              <a :class="$style.eventdate">(11月)</a>
            </dd>
          </div>
        </dl>
      </div>

      <div :id="$style.giants" v-show="show">
        <dl>
          <div>
            <dt>1993(19歳)</dt>
            <dd>
              ヤクルト戦で高津投手から プロ入り初のホームランを放つ
              <a :class="$style.eventdate">(5月2日)</a>
            </dd>
          </div>

          <div>
            <dt>1994(20歳)</dt>
            <dd>
              リーグ優勝（中日と同率最終戦決戦で勝利）
              <a :class="$style.eventdate">(10月)</a>
            </dd>
            <dd>日本シリーズ優勝（対西武ライオンズ）</dd>
          </div>

          <div>
            <dt>1995(21歳)</dt>
            <dd>初のベストナインに選ばれる</dd>
          </div>

          <div>
            <dt>1996(22歳)</dt>
            <dd>
              リーグ優勝
              <a :class="$style.eventdate">(10月)</a>
            </dd>
            <dd>打率.314、38 本塁打、99 打点でMVP を獲得</dd>
            <dd>
              日米野球に「４番」で出場
              <a :class="$style.eventdate">(11月)</a>
            </dd>
            <dd>レイノルズ投手の150キロストレートをとらえ満塁ホームランを放つ</dd>
          </div>

          <div>
            <dt>1997(23歳)</dt>
            <dd>
              広島戦で 通算100号ホームランを放つ
              <a :class="$style.eventdate">(4月27日)</a>
            </dd>
          </div>

          <div>
            <dt>1998(24歳)</dt>
            <dd>
              オールスター で（日本野球史上最高となる）
              <a :class="$style.eventdate">(7月)</a>
            </dd>
            <dd>飛距離160m（推定）の特大ホームランを放つ</dd>
            <dd>34本塁打、100打点で2冠を獲得</dd>
          </div>

          <div>
            <dt>1999(25歳)</dt>
            <dd>
              阪神戦で通算200号ホームランを放つ
              <a :class="$style.eventdate">(9月21日)</a>
            </dd>
            <dd>年間40 本塁打を達成</dd>
          </div>

          <div>
            <dt>2000(26歳)</dt>
            <dd>「4番」でシーズン開幕</dd>
            <dd>シーズンを通して「4 番」打者で活躍</dd>
            <dd>
              リーグ優勝
              <a :class="$style.eventdate">(10月)</a>
            </dd>
            <dd>日本シリーズ優勝</dd>
            <dd>42本塁打、108打点で2度目の2冠、MVP獲得</dd>
          </div>

          <div>
            <dt>2001(27歳)</dt>
            <dd>選手会長に選任</dd>
            <dd>
              1000試合目の出場となる中日戦で通算250号ホームランを放つ
              <a :class="$style.eventdate">(4月12日)</a>
            </dd>
            <dd>
              打率.333で初の首位打者に輝く
              <a :class="$style.eventdate">(10月)</a>
            </dd>
          </div>

          <div>
            <dt>2002(28歳)</dt>
            <dd>
              広島戦で 通算300号ホームランを放つ
              <a :class="$style.eventdate">(7月9日)</a>
            </dd>
            <dd>
              リーグ優勝
              <a :class="$style.eventdate">(10月)</a>
            </dd>
            <dd>50本塁打、107打点で3度目の2冠、MVP獲得</dd>
            <dd>50本塁打はセ・リーグではバース以来、日本人では落合選手以来の大記録</dd>
            <dd>
              FA宣言でメジャーリーグ挑戦を表明
              <a :class="$style.eventdate">(11月1日)</a>
            </dd>
          </div>
        </dl>
      </div>

      <div :id="$style.yankees1" v-show="show">
        <dl>
          <div>
            <dt>2003(29歳)</dt>
            <dd>
              ヤンキースと３年契約
              <a :class="$style.eventdate">(1月14日)</a>
            </dd>
            <dd>
              ブルージェイズ戦、初打席でハラデー投手から初ヒット
              <a :class="$style.eventdate">(3月31日)</a>
            </dd>
            <dd>
              ツインズ戦でメイズ投手から メジャー初ホームラン （グランドスラム）を放つ
              <a :class="$style.eventdate">(4月8日)</a>
            </dd>
            <dd>
              週間MVP（6 月24 日～ 6 月30 日）を獲得
              <a :class="$style.eventdate">(7月1日)</a>
            </dd>
            <dd>
              ６月の月間最優秀新人賞を獲得
              <a :class="$style.eventdate">(7月3日)</a>
            </dd>
            <dd>
              アリーグ東地区優勝 シーズン成績は打率.287、16 本塁打、106 打点
              <a :class="$style.eventdate">(9月28日)</a>
            </dd>
            <dd>
              ワールドシリーズに出場
              <a :class="$style.eventdate">(10月19日)</a>
            </dd>
          </div>

          <div>
            <dt>2004(30歳)</dt>
            <dd>
              MLB 凱旋試合のレイズ戦（東京ドーム）でゴンザレス投手からホームランを放つ
              <a :class="$style.eventdate">(3月31日)</a>
            </dd>
            <dd>
              2 度目の週間MVP(5 月24 日～ 5 月30 日）を獲得 成績は打率.524、2 本塁打、7
              打点
              <a :class="$style.eventdate">(6月1日)</a>
            </dd>
            <dd>
              タイガース戦で 日米通算1500 試合連続出場達成
              <a :class="$style.eventdate">(7月15日)</a>
            </dd>
            <dd>
              アスレチックス戦、メジャーで日本人初となる20号ホームランを放つ
              <a :class="$style.eventdate">(8月4日)</a>
            </dd>
            <dd>
              ブルージェイズ戦で自己初となる2 打席連続ホームランを放つ 日本人最多1 試合6
              打点をマーク
              <a :class="$style.eventdate">(8月6日)</a>
            </dd>
            <dd>
              メジャーリーグ通算300 試合連続出場達成
              <a :class="$style.eventdate">(9月6日)</a>
            </dd>
            <dd>
              2 年連続100 打点を達成
              <a :class="$style.eventdate">(9月18日)</a>
            </dd>
            <dd>
              ツインズとのダブルヘッダーで２試合連続ホームランを放つ
              メジャーで日本人初となる30 号ホームラン
              <a :class="$style.eventdate">(9月29日)</a>
            </dd>
            <dd>
              ツインズ戦、メジャーで日本人初となる3試合連続ホームランを放つ
              <a :class="$style.eventdate">(9月30日)</a>
            </dd>
            <dd>アリーグ東地区優勝</dd>
            <dd>シーズン成績は打率.298、31 本塁打、108 打点</dd>
            <dd>
              地区シリーズ第２戦から「4 番」を務める
              <a :class="$style.eventdate">(10月6日)</a>
            </dd>
            <dd>成績は打率.412、3 本塁打、13 打点</dd>
          </div>
        </dl>
      </div>

      <div :id="$style.yankees2" v-show="show">
        <dl>
          <div>
            <dt>2005(31歳)</dt>
            <dd>
              3 度目の週間MVP（6 月13 日～ 6 月19 日）を獲得
              <a :class="$style.eventdate">(6月20日)</a>
            </dd>
            <dd>
              ツインズ戦でメジャーデビュー以来
              <a :class="$style.eventdate">(7月28日)</a>
            </dd>
            <dd>連続試合出場425 試合になりメジャーリーグ記録を更新</dd>
            <dd>
              ブルージェイズ戦で日米通算1700 試合連続出場達成
              <a :class="$style.eventdate">(8月24日)</a>
            </dd>
            <dd>
              3年連続100 打点を達成
              <a :class="$style.eventdate">(9月3日)</a>
            </dd>
            <dd>
              レイズ戦で 日米通算400 号ホームランを放つ
              <a :class="$style.eventdate">(9月7日)</a>
            </dd>
            <dd>メジャー3 年連続フル出場</dd>
            <dd>メジャー自己ベストの打率.305 を達成</dd>
            <dd>
              ヤンキースとの3年契約が終了、再びヤンキースと4年契約を結ぶ
              <a :class="$style.eventdate">(11月)</a>
            </dd>
          </div>

          <div>
            <dt>2006(32歳)</dt>
            <dd>
              レッドソックス戦、1 回表の守備中に左手首を骨折し
              <a :class="$style.eventdate">(5月11日)</a>
            </dd>
            <dd>連続試合出場が1768 試合でストップ</dd>
            <dd>
              レイズ戦で111 試合ぶりに復帰
              <a :class="$style.eventdate">(9月12日)</a>
            </dd>
            <dd>スタンディングオベーションで迎えられ、タイムリー安打を放つ</dd>
            <dd>4 打数4 安打で復帰戦を飾る</dd>
            <dd>
              レイズ戦で復帰第1 号ホームランを放つ
              <a :class="$style.eventdate">(9月14日)</a>
            </dd>
            <dd>アリーグ東地区優勝</dd>
          </div>

          <div>
            <dt>2007(33歳)</dt>
            <dd>
              マリナーズ戦で日米通算2000本安打を達成
              <a :class="$style.eventdate">(5月6日)</a>
            </dd>
            <dd>
              初の月間MVPに選ばれる
              <a :class="$style.eventdate">(7月)</a>
            </dd>
            <dd>
              ロイヤルズ戦、日本人初のMLB 通算100本塁打を達成
              <a :class="$style.eventdate">(8月5日)</a>
            </dd>
            <dd>
              右膝の内視鏡手術を受ける
              <a :class="$style.eventdate">(11月14日)</a>
            </dd>
            <dd>ワイルドカードでディビジョンシリーズ進出</dd>
            <dd>シーズン成績は143 試合出場 打率.285、25 本塁打、103 打点</dd>
          </div>
        </dl>
      </div>

      <div :id="$style.yankees3" v-show="show">
        <dl>
          <div>
            <dt>2008(34歳)</dt>
            <dd>
              インディアンス戦で自己最長17 戦連続安打を達成
              <a :class="$style.eventdate">(5月8日)</a>
            </dd>
            <dd>
              ツインズ戦で日米通算2000 試合出場を達成
              <a :class="$style.eventdate">(6月1日)</a>
            </dd>
            <dd>
              アスレチックス戦でバースディ逆転満塁ホームランを放つ
              <a :class="$style.eventdate">(6月12日)</a>
            </dd>
            <dd>
              オリオールズ戦で日米通算444 本塁打を達成し
              <a :class="$style.eventdate">(8月24日)</a>
            </dd>
            <dd>長嶋茂雄氏に並ぶ</dd>
            <dd>大リーグ通算500 打点</dd>
            <dd>
              86 年の歴史に幕を閉じるヤンキースタジアム最終戦
              <a :class="$style.eventdate">(9月21日)</a>
            </dd>
            <dd>（対オリオールズ）に8 番DH で先発出場、1 安打を放つ</dd>
          </div>

          <div>
            <dt>2009(35歳)</dt>
            <dd>
              日本人初の開幕4番で日米通算445号となる右中間本塁打を放ち、恩師である長嶋茂雄・巨人終身名監督の記録を抜く
              <a :class="$style.eventdate">(4月6日)</a>
            </dd>
            <dd>
              レンジャーズ戦で日米通算450号ホームランを放つ
              <a :class="$style.eventdate">(5月27日)</a>
            </dd>
            <dd>
              打率.274、28本塁打、90打点でシーズンを終了
              <a :class="$style.eventdate">(10月4日)</a>
            </dd>
            <dd>
              ワールドシリーズでシリーズ最多タイ記録の1試合6打点
              <a :class="$style.eventdate">(11月4日)</a>
            </dd>
            <dd>ヤンキース9年ぶりにワールドシリーズ優勝</dd>
            <dd>同シリーズで日本人選手初の最優秀選手(MVP)を獲得</dd>
            <dd>
              フリーエージェント(FA)を申請
              <a :class="$style.eventdate">(11月10日)</a>
            </dd>
            <dd>
              エンゼルスと１年契約
              <a :class="$style.eventdate">(12月16日)</a>
            </dd>
          </div>
        </dl>
      </div>

      <div :id="$style.angels" v-show="show">
        <dl>
          <div>
            <dt>2010(36歳)</dt>
            <dd>
              インディアンス戦でMLB通算1000安打を達成
              <a :class="$style.eventdate">(4月17日)</a>
            </dd>
            <dd>
              マリナーズ戦で日米通算1500打点を達成
              <a :class="$style.eventdate">(5月9日)</a>
            </dd>
            <dd>
              ロッキーズ戦でMLB通算150本塁打を達成
              <a :class="$style.eventdate">(6月27日)</a>
            </dd>
            <dd>アスレチックスと１年契約</dd>
          </div>
        </dl>
      </div>

      <div :id="$style.athletics" v-show="show">
        <dl>
          <div>
            <dt>2011(37歳)</dt>
            <dd>
              マリナーズ戦で日米通算2500安打を達成
              <a :class="$style.eventdate">(4月3日)</a>
            </dd>
            <dd>
              レンジャーズ戦で日米通算1500得点を達成
              <a :class="$style.eventdate">(5月1日)</a>
            </dd>
            <dd>
              タイガース戦で日米通算500本塁打を達成
              <a :class="$style.eventdate">(7月20日)</a>
            </dd>
            <dd>
              6年ぶり4度目の週間MVP（7 月18 日～ 7 月24 日）を獲得
              <a :class="$style.eventdate">(7月25日)</a>
            </dd>
          </div>
        </dl>
      </div>

      <div :id="$style.rays" v-show="show">
        <dl>
          <div>
            <dt>2012(38歳)</dt>
            <dd>
              タンパベイレイズとマイナー契約を結ぶ
              <a :class="$style.eventdate">(4月30日)</a>
            </dd>
            <dd>
              メジャー昇格
              <a :class="$style.eventdate">(5月28日)</a>
            </dd>
            <dd>
              新背番号35でホワイトソックス戦に6番レフトで先発出場し、今シーズン第1号ホームランを放つ
              <a :class="$style.eventdate">(5月29日)</a>
            </dd>
            <dd>
              オリオールズ戦で第2号ホームランを放つ(現役最後のホームラン)
              <a :class="$style.eventdate">(6月1日)</a>
            </dd>
            <dd>
              戦力外通告を受ける
              <a :class="$style.eventdate">(7月25日)</a>
            </dd>
            <dd>
              現役引退を表明する
              <a :class="$style.eventdate">(12月28日)</a>
            </dd>
          </div>
        </dl>
      </div>

      <div :id="$style.y2013" v-show="show">
        <dl>
          <div>
            <dt>2013(39歳)</dt>
            <dd>
              東京ドームで恩師・長嶋茂雄元巨人軍監督とともに、国民栄誉賞を受賞する
              <a :class="$style.eventdate">(5月5日)</a>
            </dd>
            <dd>
              ヤンキースと1日契約を結び、ヤンキースタジアムで引退セレモニーを行う
              <a :class="$style.eventdate">(7月28日)</a>
            </dd>
          </div>
          <div>
            <dt>
              2014～2016
              <br />(42歳)
            </dt>
            <dd>
              古巣巨人の臨時コーチとして、春季宮崎キャンプに二週間参加し選手育成に努めた
              <a :class="$style.eventdate"></a>
            </dd>
            <dd>
              ヤンキースGM特別アドバイザーとして同チーム1A2A3Aの選手育成に努めた
              <a :class="$style.eventdate"></a>
            </dd>
          </div>
          <div>
            <dt>2017(43歳)</dt>
            <dd>
              ヤンキースGM特別アドバイザーとして同チーム1A2A3Aの選手育成に努めた
              <a :class="$style.eventdate"></a>
            </dd>
          </div>
          <div>
            <dt>2018(44歳)</dt>
            <dd>
              1月15日野球殿堂入り
              <a :class="$style.eventdate"></a>
            </dd>
            <dd>
              ヤンキースGM特別アドバイザーとして同チーム1A2A3Aの選手育成に努めた
              <a :class="$style.eventdate"></a>
            </dd>
          </div>
          <div>
            <dt>
              2019～2024
              <br />(50歳)
            </dt>
            <dd>
              ヤンキースGM特別アドバイザーとして同チーム1A2A3Aの選手育成に努めている
              <a :class="$style.eventdate"></a>
            </dd>
          </div>
        </dl>
      </div>
    </div>

    <div :id="$style.read_more">
      <a @click="read_more">
        <span :class="{ [$style.upper_trai]: !show, [$style.down_trai]: show }"></span>
        <li>{{ read_title }}</li>
      </a>
    </div>
  </section>
</template>

<script lang="ts">
import Vue from "vue";
import MainTitle from "@/components/atoms/MainTitle.vue";

export default Vue.extend({
  name: "HistoryVisual",

  components: {
    MainTitle,
  },

  data: function () {
    return {
      show: false,
      read_title: "Read more",
    };
  },

  methods: {
    read_more: function () {
      if (this.show == false) {
        this.read_title = "Read less";
      } else {
        this.read_title = "Read more";
      }
      this.show = !this.show;
    },
  },
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  #history {
    margin: 70px auto !important;
    width: 90%;
    display: flex;
    // 縦に積む
    flex-wrap: wrap;
    flex-direction: column;
    // 中央揃え
    justify-content: center;
    align-items: center;

    .title {
      margin-bottom: 30px;
    }

    #chronogy {
      display: flex;
      // 縦に積む
      flex-wrap: wrap;
      flex-direction: column;

      font-size: 16px;
      // border-bottom: 2px dashed #fff;
      border-bottom: 2px dashed #403f3f;
      padding-bottom: 20px;
      margin-bottom: 10px;

      dl {
        div {
          display: flex;
          flex-wrap: wrap;
          flex-direction: column;
          margin: 7px 0;
          dt {
            float: left;
            font-size: 16px;
          }
          dd {
            // margin-left: 100px;
          }
        }
      }
    }
    #read_more a {
      margin: auto;
      list-style: none;
      font-size: 16px;
      // color: #fff;
      color: #403f3f;
      cursor: pointer;
      display: flex;
      .upper_trai {
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        // border-top: 15px solid #fff;
        border-top: 15px solid #403f3f;
        margin-top: 4px;
        margin-right: 10px;
      }
      .down_trai {
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        // border-bottom: 15px solid #fff;
        border-bottom: 15px solid #403f3f;
        margin-top: 4px;
        margin-right: 10px;
      }
    }
  }
}
@media only screen and (min-width: 1024px) {
  #history {
    margin: 0px auto !important;
    width: 700px;
    display: flex;
    // 縦に積む
    flex-wrap: wrap;
    flex-direction: column;
    // 中央揃え
    justify-content: center;
    align-items: center;

    .title {
      margin-bottom: 30px;
    }

    #chronogy {
      display: flex;
      // 縦に積む
      flex-wrap: wrap;
      flex-direction: column;

      font-size: 15px;
      border-bottom: 2px dashed #403f3f;
      padding-bottom: 20px;
      margin-bottom: 10px;

      dt {
        float: left;
      }
      dd {
        margin-left: 100px;
      }
    }
    #read_more a {
      margin: auto;
      list-style: none;
      font-size: 20px;
      cursor: pointer;
      display: flex;
      .upper_trai {
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 15px solid #403f3f;
        margin-top: 8px;
        margin-right: 12px;
      }
      .down_trai {
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 15px solid #403f3f;
        margin-top: 7px;
        margin-right: 12px;
      }
    }
  }
}
</style>
